import { imageUrl } from '@helpers/imageUrl';
import React from 'react';
import S from './NavigationPromo.styles';
const NavigationPromo = ({ content, image, title }) => {
    return (React.createElement(S.Container, null,
        image && (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { alt: "", loading: "lazy", src: imageUrl(image, { height: 230, width: 300, dpr: 1 }), srcSet: [
                    `${imageUrl(image, { height: 230, width: 300, dpr: 1 })} 1x`,
                    `${imageUrl(image, { height: 230, width: 300, dpr: 2 })} 2x`,
                ].join(',') }))),
        title && React.createElement(S.Title, null, title),
        content && React.createElement(S.Content, null, content)));
};
export default NavigationPromo;
